import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { ClearJunctionService } from '../services/clearjunction.service';
import { EditClearJTransactions } from '../editclearJtransactions/editclearJtransactions.component';
@Component({
    selector: 'app-clearjunctiontransaction',
    templateUrl: './clearjunctiontransaction.component.html',
    styleUrls: ['./clearjunctiontransaction.component.css']
})

export class ClearJunctionTransactionsComponent implements OnInit {
    displayedColumns = [
        'action',
        'orderReference',
        'clientOrder',
        'transactionType',
        'currency',
        'amount',
        'operationCurrency',
        'operationAmount',
        'status',
        'product',
        'client',
        'clientId',
        'description',
        'subStatus',
        'walletUuid',
        'messages',
        'payerRequisite',
        'payeeRequisite',
        'payeeName',
        'paymentMethod',
        'is_processed',
        'createdAt',
        'operTimestamp'
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<cjunctionData>;
    pageSize = 10;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private clearJunction: ClearJunctionService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.clearJunction.getClearJunctionTransactions(this.filter).subscribe((success) => {
                let cjunctionRes = success.map(cjunctionTrans => {
                    cjunctionTrans.createdAt = moment(cjunctionTrans.createdAt).format('MM/DD/YY h:mm:ss A');
                    return cjunctionTrans;
                })
                this.dataSource = new MatTableDataSource(cjunctionRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const clearjunctionaudit = await this.dataSource.filteredData.map(x => ({
                orderReference: x.orderReference,
                clientOrder: x.clientOrder,
                currency: x.currency,
                amount: x.amount,
                status: x.status,
                operationCurrency: x.operationCurrency,
                operationAmount: x.operationAmount,
                subStatus: x.subStatus,
                walletUuid: x.walletUuid,
                transactionType: x.transactionType,
                messages: x.messages,
                payerRequisite: x.payerRequisite,
                payeeRequisite: x.payeeRequisite,
                payeeName: x.payeeName,
                paymentMethod: x.paymentMethod,
                description: x.description,
                client: x.client,
                clientId: x.clientId,
                product: x.product,
                is_processed: x.is_processed,
                createdAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(clearjunctionaudit, "clearjunctiontrans");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
    isButtonEnabled(row: any): boolean {
        return (
            (row.transactionType === 'Payin' && (row.status === 'captured' || row.status === 'settled') && row.product == '' && row.client == '')
        );
    }

    editClearJunctionTrans(element) {
        const preparedData = {
            _id: element._id,
            orderReference: element.orderReference,
            clientOrder: element.clientOrder,
            currency: element.currency,
            amount: element.amount,
            description: element.description,
        }
        this.dialog.open(EditClearJTransactions, {
            width: '500px',
            data: preparedData
        }).afterClosed().subscribe(result => {
            this.applyRefreshData();
        });
    }
}
export interface cjunctionData {
    orderReference: string,
    clientOrder: string,
    currency: number,
    amount: number,
    operationCurrency: number,
    operationAmount: number,
    subStatus: number,
    status: number,
    walletUuid: number,
    transactionType: number,
    messages: string,
    payerRequisite: string,
    payeeRequisite: string,
    payeeName: string,
    paymentMethod: string,
    description: string,
    client: string,
    clientId: string,
    product: string,
    is_processed: string,
    createdAt: string,
} 


// WEBPACK FOOTER //
// ./src/app/clearjunctiontransactions/clearjunctiontransaction.component.ts